import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={30}
            height={30}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect x={0.5} y={0.5} width={29} height={29} rx={14.5} fill="#fff" />
        <rect x={0.5} y={0.5} width={29} height={29} rx={14.5} stroke={theme["#0EA59D"]} />
        <path
            d="M19.166 7.917h-8.333c-2.5 0-4.167 1.25-4.167 4.166v5.833c0 2.917 1.667 4.167 4.167 4.167h8.333c2.5 0 4.167-1.25 4.167-4.166v-5.834c0-2.917-1.667-4.167-4.167-4.167zm.392 5.075l-2.609 2.083c-.55.442-1.25.658-1.95.658s-1.408-.216-1.95-.658l-2.608-2.083a.641.641 0 01-.1-.884.623.623 0 01.875-.1l2.608 2.084c.634.508 1.709.508 2.342 0l2.608-2.084a.615.615 0 01.875.1.632.632 0 01-.091.883z"
            fill={theme["#0EA59D"]}
        />
        </svg>
    )
}
  
  export default SvgComponent